module.exports = __webpack_public_path__ + "static/media/infographie-agd_sm.c1acebbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/infographie-agd_sm.png
// module id = 192
// module chunks = 0